import { createContext, useContext } from 'react';
import { MultiApp } from '@/config/context';
import { ENV } from '@/infrastructure/env-config';
import { ConfigStore } from '@/presentation/store/config';
import { CustomEventStore } from '@/presentation/store/custom-events';
import { DefectStore } from '@/presentation/store/defect';
import { ElectricStore } from '@/presentation/store/electric';
import { FieldStore } from '@/presentation/store/field';
import { FormListConfigStore } from '@/presentation/store/form-list-config';
import { IssueStore } from '@/presentation/store/issue';
import { LayoutStore } from '@/presentation/store/layout';
import { OverviewStore } from '@/presentation/store/overview';
import { ProductStore } from '@/presentation/store/product';
import { RightlyStore } from '@/presentation/store/rightly';
import { TapdStore } from '@/presentation/store/tapd';
import { AiStore } from './ai';
import { AppStore } from './app';
import { ProductProStore } from './product-pro';

const productStores: Record<MultiApp, any> = {
  [MultiApp.WOA]: ProductStore,
  [MultiApp.Internal]: ProductStore,
  [MultiApp.Pro]: ProductProStore,
  [MultiApp.Sgp]: ProductProStore,
  [MultiApp.Eu]: ProductProStore,
  [MultiApp.Dji]: ProductProStore,
};


enum StoreName {
  LayoutStore = 'LayoutStore',
  TapdStore = 'TapdStore',
  DefectStore = 'DefectStore',
  ProductStore = 'ProductStore',
  FieldStore = 'FieldStore',
  IssueStore = 'IssueStore',
  OverviewStore = 'OverviewStore',
  RightlyStore = 'RightlyStore',
  ConfigStore = 'ConfigStore',
  ElectricStore = 'ElectricStore',
  AppStore = 'AppStore',
  CustomEventStore = 'CustomEventStore',
  AiStore = 'AiStore',
  FormListConfigStore = 'FormListConfigStore',
}

function CreateStore() {
  return {
    LayoutStore: new LayoutStore(),
    TapdStore: new TapdStore(),
    DefectStore: new DefectStore(),
    ProductStore: new productStores[ENV.currentAppVersion as MultiApp],
    FieldStore: new FieldStore(),
    IssueStore: new IssueStore(),
    OverviewStore: new OverviewStore(),
    RightlyStore: new RightlyStore(),
    ConfigStore: new ConfigStore(),
    ElectricStore: new ElectricStore(),
    AppStore: new AppStore(),
    CustomEventStore: new CustomEventStore(),
    AiStore: new AiStore(),
    FormListConfigStore: new FormListConfigStore(),
  };
}

const stores = CreateStore();
const StoresContext = createContext(stores);
const useStores = () => useContext(StoresContext);

export {
  stores,
  StoresContext,
  StoreName,
  useStores,
};
